"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stateChangeHandler;

var _midiMessageHandler = _interopRequireDefault(require("./midiMessageHandler"));

var _utilities = require("./utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stateChangeHandler(event, device) {
  const {
    name,
    type,
    state,
    connection
  } = event.port; // ignore other devices

  if (!name.includes(device.deviceName)) return; // if(!isValidPort(name, true)) return

  if (device._debug) console.log(`>> ${name} - ${type} : ${state} ${connection}`); // bootloader

  if (name.toLowerCase().includes('bootloader') && type === 'output') {
    device.emit('bootloader', state === 'connected' ? true : false);
    device.connection.bootloader.connected = state === 'connected' ? true : false;
  } else {
    // device inputs
    // update connection status
    device.connection[type]['connected'] = state === 'connected' ? true : false;
    device.connection[type]['open'] = connection === 'open' ? true : false;
    const {
      input,
      output
    } = device.connection; // secondary connections

    if ((0, _utilities.isSecondaryConnect)(device.connection)) {
      if (!device.initMIDI) {
        // run init
        device._init(); // setup midi event listener


        device.input.addEventListener('midimessage', event => (0, _midiMessageHandler.default)(event, device), false); // emit after delay

        setTimeout(() => device.emit('connectsecondary'), 100);
      }
    } // reconnections


    if ((0, _utilities.isReconnect)(device.connection)) device.emit('reconnect'); // disconnections

    if ((0, _utilities.isDisconnect)(device.connection)) {
      device.connection.input.previous = true;
      device.connection.output.previous = true;
      device.emit('disconnect');
    }
  }
}